/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editlisting1Inputs */

const en_editlisting1 = /** @type {(inputs: Editlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Listing`)
};

const de_editlisting1 = /** @type {(inputs: Editlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit Listing" |
*
* @param {Editlisting1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editlisting1 = /** @type {((inputs?: Editlisting1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editlisting1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editlisting1(inputs)
	return de_editlisting1(inputs)
});
export { editlisting1 as "editListing" }